import type { BackendRouteDefinition } from '../types';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S4-WB1
// (PRA-791). Now served by `api-core-node` at
// `POST /api/public/engagement-letters::record-view`. The legacy
// `recordSignaturePortalView` callable continues to exist in
// `cloudFunctions/` until S9-WB2.
//
// Telemetry-only — the response is ignored by the firms client.
export const recordSignaturePortalViewRoute = {
  transport: 'api',
  method: 'POST',
  path: '/public/engagement-letters:record-view',
} as const satisfies BackendRouteDefinition;
